import { render, staticRenderFns } from "./ReportScoreFramingham.vue?vue&type=template&id=b4fbd2b0"
import script from "./ReportScoreFramingham.vue?vue&type=script&lang=js"
export * from "./ReportScoreFramingham.vue?vue&type=script&lang=js"
import style0 from "./ReportScoreFramingham.vue?vue&type=style&index=0&id=b4fbd2b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports